module.exports = __webpack_public_path__ + "media/images/template-d6ae2630e191c5584c4bba4738572626.png";